import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-12 col-md-5 offset-md-1" }
const _hoisted_3 = { class: "form-group" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { for: "member-id" }, " Member ID ", -1 /* HOISTED */)
const _hoisted_5 = { class: "form-group" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "group-name" }, " Group Name ", -1 /* HOISTED */)
const _hoisted_7 = { class: "form-group" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "group-id" }, " Group ID ", -1 /* HOISTED */)
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { for: "relationship-to-insured" }, [
  /*#__PURE__*/_createTextVNode(" Relationship to Insured "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Relationship to Insured", -1 /* HOISTED */)
const _hoisted_12 = ["value"]
const _hoisted_13 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { for: "group-id" }, " Case Manager ", -1 /* HOISTED */)
const _hoisted_16 = { class: "form-group" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("label", { for: "employer-name" }, " Employer Name ", -1 /* HOISTED */)
const _hoisted_18 = { class: "col-12 col-md-5" }
const _hoisted_19 = {
  key: 0,
  class: "form-group"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "bill-as" }, " Bill As ", -1 /* HOISTED */)
const _hoisted_21 = ["value"]
const _hoisted_22 = { class: "form-group" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "deductible-amount" }, " Deductible Amount ", -1 /* HOISTED */)
const _hoisted_24 = { class: "form-group d-flex flex-row justify-content-between mb-1" }
const _hoisted_25 = {
  class: "w-40",
  role: "group",
  "aria-label": "Basic radio toggle button group"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "has-deductible-met",
  class: "me-2"
}, " Deductible Met ", -1 /* HOISTED */)
const _hoisted_27 = {
  class: "btn-group btn-group-toggle",
  "data-bs-toggle": "buttons"
}
const _hoisted_28 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "btn-check",
  name: "has-deductible-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_29 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_30 = [
  _hoisted_28,
  _hoisted_29
]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  class: "btn-check",
  name: "has-deductible-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_32 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = {
  key: 0,
  class: "w-60"
}
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "prior-authorization" }, " Prior Authorization Required ", -1 /* HOISTED */)
const _hoisted_36 = {
  class: "btn-group btn-group-toggle",
  "data-bs-toggle": "buttons"
}
const _hoisted_37 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "require-authorization",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_39 = [
  _hoisted_37,
  _hoisted_38
]
const _hoisted_40 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "require-authorization",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_42 = [
  _hoisted_40,
  _hoisted_41
]
const _hoisted_43 = { class: "form-group" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "copay-amount" }, " Copay Amount ", -1 /* HOISTED */)
const _hoisted_45 = { class: "form-group" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("label", { for: "coinsurance-amount" }, " Coinsurance Amount ", -1 /* HOISTED */)
const _hoisted_47 = { class: "form-group" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("label", { for: "out-of-pocket-amount" }, " Out-of-Pocket Maximum Amount ", -1 /* HOISTED */)
const _hoisted_49 = { class: "form-group" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "out-of-pocket-met" }, " Out-of-Pocket Maximum Met ", -1 /* HOISTED */)
const _hoisted_51 = {
  class: "btn-group btn-group-toggle",
  "data-bs-toggle": "buttons"
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "out-of-pocket-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_53 = /*#__PURE__*/_createTextVNode(" Yes ")
const _hoisted_54 = [
  _hoisted_52,
  _hoisted_53
]
const _hoisted_55 = /*#__PURE__*/_createElementVNode("input", {
  type: "radio",
  hidden: "",
  name: "out-of-pocket-met",
  autocomplete: "off"
}, null, -1 /* HOISTED */)
const _hoisted_56 = /*#__PURE__*/_createTextVNode(" No ")
const _hoisted_57 = [
  _hoisted_55,
  _hoisted_56
]
const _hoisted_58 = { class: "form-group" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("label", { for: "subs-first-name" }, [
  /*#__PURE__*/_createTextVNode(" Subscriber First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_60 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_61 = { class: "form-group" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("label", { for: "subs-last-name" }, [
  /*#__PURE__*/_createTextVNode(" Subscriber Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_63 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_64 = {
  key: 3,
  class: "form-group"
}
const _hoisted_65 = /*#__PURE__*/_createElementVNode("label", { for: "copay-amount" }, " Comments ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "member-id",
          type: "text",
          placeholder: "Enter Member ID",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.payer.memberId) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.memberId]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-name",
          type: "text",
          placeholder: "Enter Group Name",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.payer.groupName) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.groupName]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-id",
          type: "text",
          placeholder: "Enter Group ID",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.payer.groupId) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.groupId]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _withDirectives(_createElementVNode("select", {
          class: _normalizeClass(["form-select", `${!_ctx.v$.payer.relationshipToInsured.$error ? '' : 'field-invalid'}`]),
          name: "relationship-to-insured",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.payer.relationshipToInsured) = $event)),
          onBlur: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.relationshipToInsured.$touch && _ctx.v$.payer.relationshipToInsured.$touch(...args)))
        }, [
          _hoisted_11,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.relationshipToInsuredEnum), ([key, value]) => {
            return (_openBlock(), _createElementBlock("option", {
              key: key,
              value: value.value
            }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_12))
          }), 128 /* KEYED_FRAGMENT */))
        ], 34 /* CLASS, HYDRATE_EVENTS */), [
          [_vModelSelect, _ctx.payer.relationshipToInsured]
        ]),
        (_ctx.v$.payer.relationshipToInsured.$error)
          ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Relationship is required."))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "group-id",
          type: "text",
          placeholder: "Enter Case Manager",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.payer.caseManager) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.caseManager]
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _hoisted_17,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "employer-name",
          type: "text",
          placeholder: "Enter Employer Name",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.payer.employerName) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.employerName]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (_ctx.payer.type === _ctx.roomAndBoardTypeValue || _ctx.payer.type === _ctx.palliativeCareTypeValue)
        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
            _hoisted_20,
            _withDirectives(_createElementVNode("select", {
              class: "form-select",
              name: "bill-as",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.payer.billAsType) = $event))
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.enumToMap(_ctx.payerSequenceCodeEnum), ([key, value]) => {
                return (_openBlock(), _createElementBlock("option", {
                  key: key,
                  value: value.value
                }, _toDisplayString(value.name), 9 /* TEXT, PROPS */, _hoisted_21))
              }), 128 /* KEYED_FRAGMENT */))
            ], 512 /* NEED_PATCH */), [
              [_vModelSelect, _ctx.payer.billAsType]
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", _hoisted_22, [
        _hoisted_23,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "deductible-amount",
          type: "text",
          placeholder: "Enter Deductible Amount",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.payer.deductibleAmount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.deductibleAmount],
          [_directive_number_only]
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, [
          _hoisted_26,
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", {
                class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.deductibleMet ? 'active' : ''}`),
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.hasDeductibleMetChanged(true)))
              }, _hoisted_30, 2 /* CLASS */),
              _createElementVNode("label", {
                class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.deductibleMet ? '' : 'active'}`),
                onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.hasDeductibleMetChanged(false)))
              }, _hoisted_33, 2 /* CLASS */)
            ])
          ])
        ]),
        (_ctx.isApplicationPalliative)
          ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
              _hoisted_35,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("label", {
                    class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.requirePriorAuthorization ? 'active' : ''}`),
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.requireAuthorizationChanged(true)))
                  }, _hoisted_39, 2 /* CLASS */),
                  _createElementVNode("label", {
                    class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.requirePriorAuthorization ? '' : 'active'}`),
                    onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.requireAuthorizationChanged(false)))
                  }, _hoisted_42, 2 /* CLASS */)
                ])
              ])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_43, [
        _hoisted_44,
        _withDirectives(_createElementVNode("input", {
          class: "form-control",
          maxlength: "50",
          name: "copay-amount",
          type: "text",
          placeholder: "Enter Copay Amount",
          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.payer.copayAmount) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, _ctx.payer.copayAmount]
        ])
      ]),
      (_ctx.isApplicationPalliative)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_45, [
              _hoisted_46,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                name: "coinsurance-amount",
                type: "text",
                placeholder: "Enter Coinsurance Amount",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.payer.coinsuranceAmount) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.payer.coinsuranceAmount]
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _hoisted_48,
              _withDirectives(_createElementVNode("input", {
                class: "form-control",
                maxlength: "50",
                name: "out-of-pocket-amount",
                type: "text",
                placeholder: "Enter Out-of-Pocket Maximum Amount",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.payer.outOfPocketMaxAmount) = $event))
              }, null, 512 /* NEED_PATCH */), [
                [_vModelText, _ctx.payer.outOfPocketMaxAmount]
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _hoisted_50,
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("label", {
                    class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.isOutOfPocketMaxMet ? 'active' : ''}`),
                    onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.outOfPocketMaxMetChanged(true)))
                  }, _hoisted_54, 2 /* CLASS */),
                  _createElementVNode("label", {
                    class: _normalizeClass(`btn btn-outline-secondary ${_ctx.payer.isOutOfPocketMaxMet ? '' : 'active'}`),
                    onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.outOfPocketMaxMetChanged(false)))
                  }, _hoisted_57, 2 /* CLASS */)
                ])
              ])
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (_ctx.showSubscriberName)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_58, [
              _hoisted_59,
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-control", `${!_ctx.v$.payer.subscriberFirstName.$error ? '' : 'field-invalid'}`]),
                name: "subs-first-name",
                type: "text",
                placeholder: "Enter Subscriber First Name",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.payer.subscriberFirstName) = $event)),
                onBlur: _cache[19] || (_cache[19] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.subscriberFirstName.$touch && _ctx.v$.payer.subscriberFirstName.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.payer.subscriberFirstName]
              ]),
              (_ctx.v$.payer.subscriberFirstName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_60, "Subscriber First Name is required."))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", _hoisted_61, [
              _hoisted_62,
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["form-control", `${!_ctx.v$.payer.subscriberLastName.$error ? '' : 'field-invalid'}`]),
                name: "subs-last-name",
                type: "text",
                placeholder: "Enter Subscriber Last Name",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.payer.subscriberLastName) = $event)),
                onBlur: _cache[21] || (_cache[21] = 
//@ts-ignore
(...args) => (_ctx.v$.payer.subscriberLastName.$touch && _ctx.v$.payer.subscriberLastName.$touch(...args)))
              }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                [_vModelText, _ctx.payer.subscriberLastName]
              ]),
              (_ctx.v$.payer.subscriberLastName.$error)
                ? (_openBlock(), _createElementBlock("span", _hoisted_63, "Subscriber Last Name is required."))
                : _createCommentVNode("v-if", true)
            ])
          ], 64 /* STABLE_FRAGMENT */))
        : _createCommentVNode("v-if", true),
      (!_ctx.isApplicationPalliative)
        ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
            _hoisted_65,
            _withDirectives(_createElementVNode("textarea", {
              class: "form-control",
              id: "comments",
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.payer.comments) = $event)),
              rows: "4",
              maxlength: "300"
            }, null, 512 /* NEED_PATCH */), [
              [_vModelText, _ctx.payer.comments]
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ]))
}